export default "__VITE_ASSET__Co7mhUA___"